import pure from "./higher-order/pure";
import React from "react";

export default pure(function OpenIntercomLink({className, children}) {
  return (
    <a className={className} href="mailto:support@derbywars.com">
      {children}
    </a>
  );
});
